import { Flex, Link, Module, Text } from '@billy/design-system'
import { Trans } from 'react-i18next'

export const ClientInformationEmptyState = () => (
  <Module>
    <Module.Section>
      <Flex justifyContent="center">
        <Text>
          <Trans i18nKey="contact.detail.no_information_with_edit">
            No information. <Link onClick={undefined}>Edit</Link> your client
          </Trans>
        </Text>
      </Flex>
    </Module.Section>
  </Module>
)
